import {experiments} from 'src/shared/config'
import type {CustomParcelSizes, LocationDetectedVariant} from 'src/shared/types'

export const DEFAULT_CITIES: LocationDetectedVariant[] = [
  {
    address: 'Россия, Москва',
    geo_id: 213,
  },
  {
    address: 'Россия, Санкт-Петербург',
    geo_id: 2,
  },
  {
    address: 'Россия, Свердловская область, Екатеринбург',
    geo_id: 54,
  },
  {
    address: 'Россия, Республика Татарстан, Казань',
    geo_id: 43,
  },
]

export const DELAY_TIMEOUT_MS =
  process.env.NODE_ENV === 'development' ? 800 : 1000

export const NDD_PACKAGE_SIZES =
  experiments.parcelSizes.reduce<CustomParcelSizes>(
    (acc, {id, width, height, length, weight}) => {
      acc[id as keyof CustomParcelSizes] = {width, height, length, weight}
      return acc
    },
    {} as CustomParcelSizes,
  )
